import { render, staticRenderFns } from "./HeaderNews.vue?vue&type=template&id=5e86c738&"
import script from "./HeaderNews.vue?vue&type=script&lang=js&"
export * from "./HeaderNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports